<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import echarts from "echarts";
import resize from "@/components/chart/mixins/resize";
const temp = ["合作社数量"];
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
  },
  data() {
    return {
      chart: null,
      options: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#0A1D31",
            },
          },
        },
        legend: {
          show: true,
          orient: "horizontal",
          x: "right",
          y: "10",
          data: ["合作社数量"],
          itemWidth: 10,
          itemHeight: 10,
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(13, 255, 169, 1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(13, 255, 169, 0.3)", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          textStyle: {
            color: "#62D9AD",
            fontSize: "12",
          },
        },
        grid: {
          right: "10",
          left: "15%",
          top: "15%",
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              interval: 0,
              color: "#62D9AD",
              fontSize: 12,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#62D9AD",
              },
              width: 1,
            },
            axisTick: {
              show: false,
            },

            /*    axisLabel: {
            show: true,
            margin: '10',
            fontSize: '10',
            rotate: 45,
            textStyle: {
              color: '#ffffff' //X轴文字颜色
            }
          },
          axisLine: {
            lineStyle: {
              color: '#96A4F4'
            },
            width: 5
          }, */

            data: ["河南", "洛阳", "漯河", "开封", "驻马店", "许昌", "南阳"],
          },
        ],
        yAxis: {
          name: "单位(台)",
          type: "value",
          nameTextStyle: {
            color: "#62D9AD",
            fontSize: 10,
          },
          axisLabel: {
            interval: 0,
            color: "#62D9AD",
            fontSize: 12,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 5,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.chartData.regionProductionList = [{}];
    this.initChart();
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      let xAxisData = [];
      let series = [];
      let data = [];
      if (this.chartData.regionProductionList) {
        for (
          let index = 0;
          index < this.chartData.regionProductionList.length;
          index++
        ) {
          const el = this.chartData.regionProductionList[index];
          let color = "";
          series.push({
            name: temp[index],
            type: "bar",
            stack: "总量",
            barWidth: "25%",
            label: {
              show: false,
              position: "insideLeft",
              formatter(v) {
                if (v.value <= 0) {
                  return "";
                } else {
                  return v.value;
                }
              },
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1, //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: "rgba(13, 255 ,169,1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(13, 255 ,169, 0.3)",
                    },
                  ]
                ),
              },
            },
            data: [3200, 2200, 3010, 1234, 390, 330, 320, 332, 0],
          });
        }
        this.options.xAxis.data = this.chartData.regionList;
        this.options.series = series;
        this.chart.setOption(this.options);
      }
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
